import type { FC, SVGProps } from 'react'

export const DynamicLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 200 200"
    {...props}
  >
    <title>Dynamic</title>
    <g
      transform="translate(0,200) scale(0.1,-0.1)"
      fill="#4779FF"
      stroke="none"
    >
      <path d="M734 1492 c-46 -25 -128 -95 -229 -197 -97 -96 -121 -142 -109 -203 9 -46 35 -65 70 -52 27 11 120 88 234 197 30 28 66 61 80 73 89 74 139 124 134 132 -3 5 -24 23 -46 39 -47 33 -88 37 -134 11z" />
      <path d="M1099 1471 c-52 -35 -122 -97 -429 -377 -104 -95 -113 -102 -151 -120 -22 -9 -39 -20 -39 -23 0 -4 15 -22 33 -41 18 -19 71 -78 117 -130 134 -153 232 -250 274 -272 76 -39 162 -11 271 88 40 36 130 115 214 189 125 110 191 180 207 220 15 40 15 45 -2 81 -22 48 -34 64 -126 167 -111 126 -214 226 -243 237 -44 17 -80 11 -126 -19z" />
    </g>
  </svg>
)
